// extracted by mini-css-extract-plugin
module.exports = {"mCard":"pg","image":"qg","imageNoBackground":"rg"};